import cloneDeep from 'lodash.clonedeep';
import map from 'lodash.map';

function setAuctionType(response, type, key = 'auctions') {
  const clonedResponse = cloneDeep(response);
  const data = clonedResponse?.data?.data;

  if (data && data[key]) {
    data[key] = map(data[key], (auction) => {
      const clonedAuction = cloneDeep(auction);
      clonedAuction.type = type;
      return clonedAuction;
    });
  }
  return clonedResponse;
}

export default setAuctionType;
